export * from './rattachement.route';
export * from './rattachement.module';



// WEBPACK FOOTER //
// ./src/main/webapp/app/rattachement/index.ts